<template>
  <div class="tutorial-step">
    <slot></slot>
    <div v-if="imgSrc">
      <img v-bind:src="getImgSrc()">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: String,
    text: String,
    imgSrc: String
  },
  methods: {
    getImgSrc() {
      return require("@/assets/img/" + this.imgSrc);
    }
  }
};
</script>


<style scoped>
.tutorial-step {
  width: 100%;
  height: auto;
  text-align: left;
  background-color: var(--light-text-color);
  border-radius: 10px;
  padding: 20px;
}

img {
  width: 100%;
  max-width: 500px;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
